import { App } from 'vue'
import RuleEditor from './LpRuleEditor.vue'

RuleEditor.install = (Vue: App) => {
  Vue.component(RuleEditor.name, RuleEditor)
}

export default RuleEditor
